const type = {
  SET_COMPANY_DATA: "DCC_SET_COMPANY_DATA",
  SET_ORGANIZATION_MODULE: "SET_ORGANIZATION_MODULE",
  SET_ORGANIZATION_SELECTED: "SET_ORGANIZATION_SELECTED",
  ORGANIZATION_UNSELETED: "ORGANIZATION_UNSELETED",
  DCC_CLEAR:"DCC_CLEAR"
};
export default type;
